import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { I18nModule } from './i18n/i18n.module'

const MODULES = [
  // Angular
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  // App
  I18nModule,
]

@NgModule({
  imports: [...MODULES],
  exports: [...MODULES],
  providers: [],
})
export class UiKitModule {}
